(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["buebua-home-0"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('buebua-banner')) {
  customElements.define('buebua-banner', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      clearTimeout(this.timer);
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.slides = [...this.querySelectorAll('[data-banner-slide]')];
      this.stage = this.querySelector('[data-banner-stage]');
      this.controls = this.querySelector('[data-banner-controls]');
      this.playButton = this.querySelector('[data-banner-play]');
      this.status = this.querySelector('.bb-banner-status');
      this.index = 0;
      this.requested = 0;
      this.hovered = this.matches(':hover');
      this.playIntent = null;
      this.visible = true;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.playing = this.dataset.autoplay === 'true' && !this.motion.matches;
      this.interval = Math.max(5000, Number(this.dataset.interval) || 8000);
      if (this.slides.length < 2) return;
      this.controls.hidden = false;
      this.querySelector('[data-banner-prev]').addEventListener('click', () => this.show(this.index - 1), options);
      this.querySelector('[data-banner-next]').addEventListener('click', () => this.show(this.index + 1), options);
      this.querySelectorAll('[data-banner-index]').forEach(button => {
        button.addEventListener('click', () => this.show(Number(button.dataset.bannerIndex)), options);
      });
      this.playButton.addEventListener('pointerdown', () => { this.playIntent = !this.playing; }, options);
      this.playButton.addEventListener('pointercancel', () => { this.playIntent = null; }, options);
      this.playButton.addEventListener('blur', () => { this.playIntent = null; }, options);
      this.playButton.addEventListener('click', () => { const intent = this.playIntent; this.playIntent = null; this.playing = intent === null ? !this.playing : intent; this.refresh(); }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.playing = false; this.refresh(); }, options);
      this.motion.addEventListener('change', event => { if (event.matches) this.playing = false; this.refresh(); }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.controls.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      }, options);
      document.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index !== -1) { this.playing = false; this.refresh(); this.show(index); }
      }, options);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.schedule();
      }, { threshold: 0.15 });
      this.observer.observe(this.stage);
      this.refresh();
    }
    canPlay() { return this.playing && !this.hovered && this.visible && !document.hidden && this.isConnected; }
    schedule() {
      clearTimeout(this.timer);
      if (this.canPlay()) this.timer = setTimeout(() => this.show(this.index + 1, true), this.interval);
    }
    refresh() {
      this.playButton.setAttribute('aria-label', this.playing ? this.playButton.dataset.pauseLabel : this.playButton.dataset.playLabel);
      this.playButton.setAttribute('aria-pressed', String(this.playing));
      this.querySelector('[data-banner-play-icon]').textContent = this.playing ? 'Ⅱ' : '▶';
      this.status.setAttribute('aria-live', this.playing ? 'off' : 'polite');
      this.schedule();
    }
    async show(value, automatic = false) {
      clearTimeout(this.timer);
      const next = (value + this.slides.length) % this.slides.length;
      const request = ++this.requested;
      const image = this.slides[next].querySelector('img');
      image.loading = 'eager';
      try { await image.decode(); } catch {}
      if (request !== this.requested || !this.isConnected) return;
      if (automatic && !this.canPlay()) { this.schedule(); return; }
      this.slides.forEach((slide, index) => { slide.hidden = index !== next; });
      this.stage.dataset.position = this.slides[next].dataset.position;
      this.querySelectorAll('[data-banner-index]').forEach((button, index) => button.setAttribute('aria-pressed', String(index === next)));
      this.querySelector('[data-banner-status]').textContent = `${next + 1} / ${this.slides.length}`;
      this.index = next;
      this.schedule();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); clearTimeout(this.timer); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
